/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '../../../../../base/api';
import { SetFieldParams } from '../../../../../base/interfaces/params';
import { Messenger } from '../../../../../base/enums';

export interface Fields {
    phone: string;
    messenger: Messenger;
    smsCode?: string;
}

export interface QuickSignUpState {
    fields: Fields;
    errors: IError | null;
    shouldScrollToError: boolean;
}

const fieldsInitialState: Fields = {
    phone: '',
    messenger: Messenger.Viber,
};

const initialState: QuickSignUpState = {
    fields: fieldsInitialState,
    errors: null,
    shouldScrollToError: false,
};

export const quickSignUpSlice = createSlice({
    name: 'worker-app__quick-signup',
    initialState,
    reducers: {
        clearData: (state) => {
            state.fields = fieldsInitialState;
            state.errors = null;
            state.shouldScrollToError = false;
        },
        setField: (state, action: PayloadAction<SetFieldParams>) => {
            state.fields = {
                ...state.fields,
                [action.payload.id]: action.payload.value,
            };
            if (state.errors === null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.errorGroupName || action.payload.id]: removedError, ...errors } = state.errors;
            state.errors = errors;
        },
        setErrors: (state, action: PayloadAction<IError>) => {
            if (state.errors) {
                state.errors = {
                    ...state.errors,
                    ...action.payload,
                };
            } else {
                state.errors = action.payload;
            }
        },
        setShouldScrollToError: (state, action: PayloadAction<boolean>) => {
            state.shouldScrollToError = action.payload;
        },
        validateQuickSignUpParams: {
            reducer: () => {},
            prepare: (successCallback: () => void) => ({
                payload: { successCallback },
            }),
        },
        submitQuickSignUp: {
            reducer: () => {},
            prepare: (successCallback: () => void) => ({
                payload: { successCallback },
            }),
        },
        submitChangeConfirmationValue: {
            reducer: () => {},
            prepare: (newValue: string, recaptchaToken: string | null, callback: () => void) => ({
                payload: { newValue, recaptchaToken, callback },
            }),
        },
    },
});

export const quickSignUpActions = quickSignUpSlice.actions;
export const quickSignUpReducer = quickSignUpSlice.reducer;
